module.exports = __webpack_public_path__ + "media/homepage/builder-hero@2x-cc363329.png";